let positionButton = -1;

window.addEventListener('scroll', (e) => {
  const buttonItem = document.querySelector('.button-header');
  if (buttonItem) {
    if (positionButton < 0) positionButton = findPosY(buttonItem);
    const buttonItemSticky = document.querySelector('.button-header-sticky');
    const scrollTop = window.scrollY;
    if (scrollTop >= positionButton) {
      buttonItemSticky.classList.remove('no_visible');
    } else {
      buttonItemSticky.classList.add('no_visible');
    }
  }
});

function findPosY(obj) {
  var curtop = 0;
  if (typeof (obj.offsetParent) != 'undefined' && obj.offsetParent) {
    while (obj.offsetParent) {
      curtop += obj.offsetTop;
      obj = obj.offsetParent;
    }
    curtop += obj.offsetTop;
  } else if (obj.y) {
    curtop += obj.y;
  }
  return curtop;
}